import React from "react";

export interface WithShowProps {
  onClose?: () => void;
  isVisible: boolean;
}

interface HOCChildrenProps {
  show: () => void;
}

export interface WithShowHOCProps {
  children: (props: HOCChildrenProps) => any;
  modalChildren?: any;
}
export default <P extends WithShowProps>(
    Modal: React.ComponentType<P>
  ): React.ComponentType<
    Omit<P, "isVisible" | "onClose"> & {
      onClose?: () => void;
    } & WithShowHOCProps
  > =>
  ({
    children,
    ...props
  }: Omit<P, "isVisible" | "onClose"> & {
    onClose?: () => void;
  } & WithShowHOCProps) => {
    const [isVisible, setIsVisible] = React.useState(false);

    const hide = React.useCallback(() => {
      setIsVisible(false);
      props.onClose && props.onClose();
    }, [setIsVisible, props.onClose]);
    const show = React.useCallback(() => setIsVisible(true), [setIsVisible, props.onClose]);

    return (
      <>
        {children({ show })}

        <Modal {...(props as unknown as P)} children={props.modalChildren} isVisible={isVisible} onClose={hide} />
      </>
    );
  };
